export default {
  methods: {
    $isRouteActive(route) {
      return !!this.$route.matched.find((e) => e.name === route);
    },
  },
};
